import { render, staticRenderFns } from "./ProjectRemoveAction.vue?vue&type=template&id=83f21a56"
import script from "./ProjectRemoveAction.vue?vue&type=script&lang=js"
export * from "./ProjectRemoveAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports